import { createAction, props } from '@ngrx/store';
import { WidgetsFormState } from '../widgets.state';

/**
 * Widgets store actions.
 *
 * There is deliberately no action per form field. The signal form edits a local
 * draft of `WidgetsFormState` and commits the whole validated draft in a single
 * intent action, so adding the remaining low-level components adds properties to
 * `WidgetsFormState` — not actions, reducers or selectors.
 *
 * Payloads are restricted to the serializable `WidgetsFormState` shape so they
 * pass the root store's `strictActionSerializability` check.
 */

/** Dispatched by the widget screen when the user commits the (valid) signal form. */
export const widgetsFormCommitted = createAction('[Widgets] Form committed', props<{ form: WidgetsFormState }>());

/**
 * Dispatched by the widget screen's "write from outside the form" button. Stands
 * in for any store write the form did not originate — a rehydrate, an offline
 * sync, another component — so the draft re-seeding can be evaluated.
 */
export const widgetsFormSeeded = createAction('[Widgets] Form seeded', props<{ form: WidgetsFormState }>());

/** Dispatched by the widget screen's reset button; restores the initial values. */
export const widgetsFormReset = createAction('[Widgets] Form reset');
